import { Helmet } from "react-helmet";
import {
  Box,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import React, { useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { styled } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cssVariables from "../../../../theme/cssVariables";
import Search from "@mui/icons-material/Search";
import * as Util from "../../../../services/global.service";

import GoalWorkflow from "./GoalWorkflow"
import EvaluationWorkflow from "./EvaluationWorkflow"
import EvaluationProbationWorkflow from "./EvaluationProbationWorkflow"

import { getWorkflow } from "../../../../actions/admin/workflow";

const useStyles = makeStyles({
  plusSvg: {
    "& > path": {
      fill: cssVariables.color.primary,
      stroke: "#fff",
    },
  },
  draggingListItem: {
    background: "rgb(235,235,235)",
  },
  flexPaper: {
    flex: 1,
    minWidth: 350,
    "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1) !important",
    "border-radius": "10px !important        ",
  },
  tab: {
    fontSize: "16px !important",
    fontWeight: "300 !important",
    // color: "#A3A3A3 !important",
    "&.Mui-selected": {
      color: cssVariables.color.primary + " !important",
    },
  },
  root: {
    display: "flex",
    width: "100%",
    flexWrap: "wrap",
  },
  tableHeader: {
    fontWeight: 500,
    fontSize: "14px!important",
    color: "#A0A0A0",
  },
  profileContainer: {
    width: 60,
    height: 60,
    borderRadius: "50%",
    marginTop: 3,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
})
const styles = {
  link: {
    color: "#5DA196",
    cursor: "pointer",
  },
  end: {
    color: "#A3A3A3",
  },
};

// main component
const EditWorkflow = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { id } = useParams()
  const dispatch  = useDispatch()
	const { state } = useLocation()

  const goTo = (route, data) => {
    if (data) {
      navigate("/admin" + route, { replace: false, state: data });
    } else {
      navigate("/admin" + route, { replace: false });
    }
  }

  return (
    <Box sx={{ maxHeight: "100%", overflowY: "auto" }}>
      <Helmet>
        <title>Admin - Edit Workflow | PMS </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goTo("/workflow")}>
                {` ${t("adminWorkflow.label.title")}`}
              </span>{" "}
              /
              <span style={styles.end}>
                {` ${t("adminWorkflow.label.editWorkflow")}`}
              </span>
            </Typography>
          </Grid>
					{ (id && id !== "") &&
						<>
							<Grid container>
								<Grid item>
									<Typography color="#404349" fontSize={36} fontWeight="600">
										{t("adminWorkflow.label.editWorkflow")}
									</Typography>
								</Grid>
							</Grid>
							{/* ---------------------- Workflow Type Display ---------------------- */}
							{ 
								state?.type === "Goal" || state?.type === "goal" ? <GoalWorkflow mode="edit" id={id} /> : 
								state?.type === "evaluate" || state?.type === "Evaluate" ? <EvaluationWorkflow mode="edit" id={id} /> : 
                state?.type === "probation" || state?.type === "Probation" ? <EvaluationProbationWorkflow mode="edit" id={id} /> : <></>
							}
						</>
					}
        </Container>
      </Box>
    </Box>
  )
}

export default EditWorkflow;
